import { cn } from "@/lib/utils";
import type { HeaderContext, SortDirection } from "@tanstack/react-table";
import { ChevronDown, ChevronUp } from "lucide-react";

const sortKeys: Record<SortDirection, () => React.ReactNode> = {
  asc: () => {
    return <ChevronDown className="w-3 h-3" />;
  },
  desc: () => {
    return <ChevronUp className="w-3 h-3" />;
  },
};

type HeaderCellProps<TData, TValue> = {
  children: React.ReactNode;
  align?: "left" | "right";
  header: HeaderContext<TData, TValue>;
};

export const HeaderCell = <TData, TValue>({
  children,
  header,
  align = "left",
}: HeaderCellProps<TData, TValue>) => {
  const isSorted = header.column.getIsSorted();
  const sortKey = isSorted ? sortKeys[isSorted] : null;
  const canSort = header.column.getCanSort();

  return (
    <div
      className={cn(
        "flex items-center",
        align === "right" && "justify-end",
        align === "left" && "justify-start"
      )}
    >
      <button
        className={cn(
          "flex gap-1 items-center py-2 rounded-sm font-normal",
          canSort && "cursor-pointer select-none",
          align === "right" && "flex-row-reverse",
          !sortKey && align === "right" && "ml-4",
          !sortKey && align === "left" && "mr-4"
        )}
        onClick={header.column.getToggleSortingHandler()}
      >
        {children}
        {sortKey ? sortKey() : null}
      </button>
    </div>
  );
};
